/**
 * A Role
 * @param {string} name - Name
 * @param {string} weez_orga_id - Weezevent ID
 * @returns {Class} - Role instance
 */
class Role {
	constructor({
		slug,
		name,
		capacities
	} = {}) {
		this._slug = slug;
		this._name = name;
		this._capacities = capacities;
	}

	getKey() {
		return this._slug;
	}

	toString() {
		return this._name;
	}

	getSlug() {
		return this._slug;
	}

	getName() {
		return this._name;
	}

	getCapacities() {
		return this._capacities || [];
	}
}
export default Role;
